import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { useCallback, useMemo } from 'react';

export interface ColumnActionButtonProps {
  title: string;
  icon: React.JSX.Element;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: (entry: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disabled?: boolean | ((entry: any) => boolean);
  processing?: boolean;
}

export default function ColumnActionButton({
  title,
  icon,
  onClick,
  disabled,
  processing,
  entry,
}: ColumnActionButtonProps & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: any;
}): React.JSX.Element {
  const progressSize = 24;

  const iconElement = useMemo(() => {
    if (!!processing) {
      return <CircularProgress color="inherit" style={{ width: progressSize, height: progressSize }} />;
    }

    return icon;
  }, [icon, processing]);

  const onClickCallback = useCallback(() => {
    if (processing) {
      return;
    }

    onClick(entry);
  }, [onClick, processing, entry]);

  const isDisabled = useMemo(() => {
    if (typeof disabled === 'function') {
      return disabled(entry);
    }

    return !!disabled;
  }, [entry, disabled]);

  return (
    <Tooltip title={title} placement={'top'}>
      <div>
        <IconButton disabled={isDisabled} size={'large'} onClick={() => onClickCallback()}>
          {iconElement}
        </IconButton>
      </div>
    </Tooltip>
  );
}
